import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from '../I18n/index.js';
import { Select } from 'antd';
const { Option } = Select;
const LangSelect = ({ langs, value, onChange }) => {
    const { intl } = useI18n();
    return (_jsx(Select, { value: value, onChange: onChange, className: "lang-select", children: langs.map((lang) => (_jsx(Option, { value: lang, children: intl.formatMessage({ id: lang }) }, lang))) }));
};
export default LangSelect;
